export function formatGroupCreatedDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function mapApiGroupStatus(status, isSuspended) {
  if (isSuspended) return "archived";
  const s = (status || "").toLowerCase();
  if (s === "archived" || s === "suspended") return "archived";
  return "active";
}

export function mapApiGroupToTableRow(group) {
  if (!group) return null;

  const status = mapApiGroupStatus(group.status, group.is_suspended);

  return {
    id: group.id,
    name: group.title || group.name || "",
    totalTeams: group.total_teams ?? 0,
    totalAgents: group.total_agents ?? 0,
    totalChats: group.total_chats ?? 0,
    totalTickets: group.total_tickets ?? 0,
    teamsDisplay: group.teams_display || "—",
    status,
    createdDate: formatGroupCreatedDate(group.created_at),
    avatar: group.group_image || null,
    raw: group,
  };
}

export function mapApiGroupTeamToUi(team) {
  if (!team) return null;

  return {
    id: team.id,
    name: team.name || "",
    description: team.description || "",
    status: mapApiGroupStatus(team.status, team.is_archived),
    agents: team.agents_count ?? 0,
    chats: team.total_chats ?? 0,
    tickets: team.total_tickets ?? 0,
    raw: team,
  };
}

export function mapApiGroupToDetailView(group) {
  if (!group) return null;

  const summary = group.summary || {};
  const information = group.information || {};
  const teams = (group.teams || []).map(mapApiGroupTeamToUi).filter(Boolean);

  return {
    id: group.id,
    name: group.title || group.name || "",
    description: group.description || "",
    avatar: group.group_image || null,
    status: mapApiGroupStatus(information.status || group.status, information.is_suspended ?? group.is_suspended),
    createdDisplay: information.created_display || formatGroupCreatedDate(information.created_at || group.created_at),
    stats: {
      totalTeams: summary.total_teams ?? group.total_teams ?? teams.length,
      totalAgents: summary.total_agents ?? group.total_agents ?? 0,
      totalChats: summary.total_chats ?? group.total_chats ?? 0,
      totalTickets: summary.total_tickets ?? group.total_tickets ?? 0,
    },
    teams,
    settings: group.settings || null,
    raw: group,
  };
}

export function computeGroupTabCounts(tabCounts = {}) {
  return {
    all: tabCounts.all ?? 0,
    active: tabCounts.active ?? 0,
    archived: tabCounts.archived ?? 0,
  };
}

export function buildGroupWritePayload({ name, status }) {
  const payload = {};
  if (name != null && String(name).trim()) payload.title = String(name).trim();
  if (status) payload.status = status;
  return payload;
}
